import { resolveHomepageVariant } from '../homepageConfig';
import { LandingPageClassic } from './LandingPageClassic';
import { LandingPageEngaging } from './LandingPageEngaging';

export function LandingPage() {
  const variant = resolveHomepageVariant();
  return variant === 'engaging' ? <LandingPageEngaging /> : <LandingPageClassic />;
}
